export default {
  namespaced: true,
  state: {
    main: { /* 캘린더 형태 일정 표시 - 읽기 전용 - 선택연월을 이용하여 레포트 데이터를 조회함 */
      ym: '202103', // 선택된 연월
      items: [
        {
          date: '20210317',
          category: 'CHECK', // 업무 카테고리 - 아이콘과 연계 (CHECK, FAIL, ISSUE)
          line: 'FPCA',
          time: ['0900', '1100'],
          content: 'Line detail check',
          result: 'Check completed'
        },
        {
          date: '20210317',
          category: 'CHECK', // 업무 카테고리 - 아이콘과 연계 (CHECK, FAIL, ISSUE)
          line: 'FPCA',
          time: ['0900', '1100'],
          content: 'Line detail check',
          result: 'Check completed'
        }
      ]
    },
    checkSheet: {
      /*
      각 화면의 공통요소를 최대한 활용하고

        설비 그룹별로 Equipment/Compressor/Transformer/AHU/Boiler 등의 세부 메뉴, 각 설비들의 점검 항목 결과 관리
        서브메뉴 젠체 공통 : 날짜, 엑셀 다운로드
        Equipment 는 라인 별로 그룹핑
        Compressor 는 Compressor 별로 공통 항목들이 변경됨 -> 테이블 타입으로 작성 가능 할듯
        Transformer 는

        equipment
          title
          type - line/compressor/transformer/ahu/boiler
          factors: [
          ]
      */
      equipment: { /* 라인별, 날짜별 설비에 대한 체크 사항 저장 */
      },
      compressor: {},
      transformer: {},
      ahu: {},
      boiler: {}
    },
    workReport: {
      daily: {},
      repair: {}
    },
    schedule: {
      monthly: {},
      daily: {}
    },
    equipment: {
      ledger: {},
      drawing: {},
      repairHistory: {},
      plcProgram: {},
      software: {},
      parameter: {},
      maintenanceGuide: {},
      troubleShooting: {},
      settingGuide: {},
      manual: {},
      contactSupplier: {}
    },
    sparePart: {
      spareList: {},
      stocktaking: {}
    },
    manufacturingAndRepairRequest: {
      request: {},
      result: {}
    },
    requestOffer: {
      manufacturing: {},
      construct: {},
      purchase: {},
      offerList: {},
      companyRegistration: {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/samples.js